/* global swal:false */
;(function () {
  'use strict'

  angular
    .module('admin.users.details.cash_ledgers', ['admin.users.details.cash_ledgers.bundles'])
    .controller('CashLedgersAdminCtrl', CashLedgersAdminCtrl)

  /** @ngInject */
  function CashLedgersAdminCtrl($scope, $stateParams, $state, UsersService, UploadService) {
    var vm = this
    vm.items = []
    vm.userId = $stateParams.parentId
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
    vm.balance = 0
    vm.balancePage = [
      {},
      {
        page: 1,
        balance: vm.balance,
      },
    ]
    vm.pageNow = 1
    vm.isSame = { is: false, index: 0 }
    vm.currentFilter = 'All'

    vm.sortType = 'ts-m-desc'
    vm.sortReverse = false

    vm.filter = 'All'
    vm.sort = [
      'All',
      'All Cash In',
      'All Cash Out',
      'Deposits',
      'Withdrawals',
      'Admin Adjustments',
      'Deposit Fees',
      'Withdrawal Fees',
      'Bundle Purchases',
      'Listing Sales',
      'Listing Purchases',
      'Deposit Refunds',
      'Coin Purchases',
      'Whole Account Sale',
      'Whole Account Purchase',
      'Account Transfer Fee',
      'Crypto Deposit',
      'Blockchain Transaction Fee',
      'Coin To Cash Conversion',
      'Store Credit',
    ]

    const types = [
      { id: 1, name: 'Deposit' },
      { id: 2, name: 'Withdrawal' },
      { id: 3, name: 'Admin Adjustment' },
      { id: 4, name: 'Deposit Fee' },
      { id: 5, name: 'Withdrawal Fee' },
      { id: 6, name: 'Pending Withdrawal' },
      { id: 7, name: 'Bundle Purchase' },
      { id: 8, name: 'Whole Account Sale' },
      { id: 9, name: 'Whole Account Purchase' },
      { id: 10, name: 'Account Transfer Fee' },
      { id: 11, name: 'Initial Signup' },
      { id: 12, name: 'Reward Inviter' },
      { id: 13, name: 'Reward Invitee' },
      { id: 14, name: 'Reward Add Facebook' },
      { id: 15, name: 'Cash Reward' },
      { id: 16, name: 'Listing Sale' },
      { id: 17, name: 'Listing Purchase' },
      { id: 18, name: 'Promo Code Cash Claim' },
      { id: 19, name: 'Offer Cash Claim' },
      { id: 20, name: 'Coupon Credit' },
      { id: 21, name: 'Deposit Refund' },
      { id: 22, name: 'Coin Purchase' },
      { id: 23, name: 'Crypto Deposit' },
      { id: 24, name: 'Blockchain Transaction Fee' },
      { id: 25, name: 'Coin to Cash Conversion' },
      { id: 26, name: 'Store Credit' },
      { id: 27, name: 'Burn Credits' },
      { id: 28, name: 'Free Cash Claim' },
      { id: 29, name: 'Bundle Award' },
      { id: 30, name: 'Game Token Purchase' },
    ]

    vm.sortBy = function (item, pageNumber) {
      vm.totalItems = 0
      vm.currentFilter = item

      if (pageNumber !== undefined) {
        vm.pageNow = pageNumber
      } else {
        vm.pageNow = 1
      }

      switch (item) {
        case 'All':
          load(vm.pageNow)
          break
        case 'All Cash In':
          load(vm.pageNow, undefined, 'in')
          break
        case 'All Cash Out':
          load(vm.pageNow, undefined, 'out')
          break
        case 'Deposits':
          load(vm.pageNow, 1)
          break
        case 'Withdrawals':
          load(vm.pageNow, 2)
          break
        case 'Admin Adjustments':
          load(vm.pageNow, 3)
          break
        case 'Deposit Fees':
          load(vm.pageNow, 4)
          break
        case 'Withdrawal Fees':
          load(vm.pageNow, 5)
          break
        case 'Bundle Purchases':
          load(vm.pageNow, 7)
          break
        case 'Whole Account Sale':
          load(vm.pageNow, 8)
          break
        case 'Whole Account Purchase':
          load(vm.pageNow, 9)
          break
        case 'Account Transfer Fee':
          load(vm.pageNow, 10)
          break
        case 'Listing Sales':
          load(vm.pageNow, 16)
          break
        case 'Listing Purchases':
          load(vm.pageNow, 17)
          break
        case 'Deposit Refunds':
          load(vm.pageNow, 21)
          break
        case 'Coin Purchases':
          load(vm.pageNow, 22)
          break
        case 'Crypto Deposit':
          load(vm.pageNow, 23)
          break
        case 'Blockchain Transaction Fee':
          load(vm.pageNow, 24)
          break
        case 'Coin To Cash Conversion':
          load(vm.pageNow, 25)
          break
        case 'Store Credit':
          load(vm.pageNow, 26)
          break
      }
    }

    UsersService.get($stateParams.parentId).then(function (result) {
      vm.user = result.results
    })

    load(1)

    var oldSortType
    function load(pageNumber, filter, flow) {
      vm.balance = 0
      if (pageNumber === 1) {
        vm.pagination.current = 1
        vm.balance = 0
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25
        vm.oldPage = vm.currentPage - 25
      } else {
        vm.first = false
      }

      oldSortType = angular.copy(vm.sortType)
      if (flow === undefined) {
        if (filter !== undefined) {
          UsersService.listCashLedgersFilter(
            $stateParams.parentId,
            filter,
            vm.oldPage,
            25,
            vm.sortType,
          ).then(success)
        } else {
          UsersService.listCashLedgers($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(
            success,
          )
        }
      } else {
        UsersService.listCashLedgersFlow(
          $stateParams.parentId,
          flow,
          vm.oldPage,
          25,
          vm.sortType,
        ).then(success)
      }

      function success(result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct
        }

        for (var i = 0; i < result.results.length; i++) {
          switch (result.results[i].k) {
            case 1:
              result.results[i].kname = 'Deposit'
              break
            case 2:
              result.results[i].kname = 'Withdrawal'
              break
            case 3:
              result.results[i].kname = 'Admin Adjustment'
              break
            case 4:
              result.results[i].kname = 'Deposit Fee'
              break
            case 5:
              result.results[i].kname = 'Withdrawal Fee'
              break
            case 6:
              result.results[i].kname = 'Pending Withdrawal'
              break
            case 7:
              result.results[i].kname = 'Bundle Purchase'
              break
            case 8:
              result.results[i].kname = 'Whole Account Sale'
              break
            case 9:
              result.results[i].kname = 'Whole Account Purchase'
              break
            case 10:
              result.results[i].kname = 'Account Transfer Fee'
              break
            case 16:
              result.results[i].kname = 'Listing Sale'
              break
            case 17:
              result.results[i].kname = 'Listing Purchase'
              break
            case 21:
              result.results[i].kname = 'Deposit Refund'
              break
            case 22:
              result.results[i].kname = 'Coin Purchase'
              break
            case 23:
              result.results[i].kname = 'Crypto Deposit'
              break
            case 24:
              result.results[i].kname = 'Blockchain Transaction Fee'
              break
            case 25:
              result.results[i].kname = 'Coin To Cash Conversion'
              break
            case 26:
              result.results[i].kname = 'Store Credit'
              break
            case 27:
              result.results[i].kname = 'Burn Credits'
              break
            case 28:
              result.results[i].kname = 'Free Cash Claim'
              break
            case 29:
              result.results[i].kname = 'Bundle Award'
              break
            case 30:
              result.results[i].kname = 'Game Token Purchase'
              break
            default:
              result.results[i].kname = 'Unknown'
              break
          }

          switch (result.results[i]['k-cr']) {
            case 1:
              result.results[i]['k-cr'] = 'Primary Market'
              break
            case 2:
              result.results[i]['k-cr'] = 'Primary and Aftermarket'
              break
            case 3:
              result.results[i]['k-cr'] = 'Credit'
              break
          }

          result.results[i].ts = new Date(
            parseInt(
              result.results[i].ts
                .toString()
                .substring(0, result.results[i].ts.toString().length - 3),
            ),
          )
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
          if (vm.balance === 0) {
            vm.balance = result.results[i].amt
          } else {
            vm.balance = vm.balance + result.results[i].amt
          }

          result.results[i].balance = vm.balance
        }

        vm.items = result.results
      }
    }

    vm.pageChanged = function (newPage) {
      vm.sortType = oldSortType
      vm.sortBy(vm.currentFilter, newPage)
    }

    vm.bp = function (item) {
      if (item.bp !== null) {
        $state.go('admin.users.details.cash_ledgers.bundles', {
          bpId: item.bp.id,
          bundleId: item.bp.b.id,
          setId: item.bp.b['id-s'],
        })
      }
    }

    vm.sortFilter = function (type) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      vm.sortBy(vm.currentFilter, vm.pagination.current)
    }
  }
})()
